const messages = {
  title: "Wartungsarbeiten!",
  description:
    'Aktuell finden notwendige Wartungsarbeiten an den Servern statt.<br/><br/>Daher steht Ihnen aktuell der Zugang zu <b>BRIDGESTONE <span class="text-danger">PLUS</span></b> nicht zur Verfügung.<br/><br/>Wir bitten um Ihre Geduld und bedanken uns für Ihr Verständnis.<br/><br/> Ihr Bridgestone Team',
};

export default {
  messages,
};
